import { Injectable } from '@angular/core';
import { TOASTER_TYPE, ToasterModel } from './toaster.model';
import { BehaviorSubject, filter, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  toasters$ = new BehaviorSubject<Array<ToasterModel>>([]);

  ID(): string {
    return Math.random().toString(36).substr(2, 8);
  }

  init(toaster: ToasterModel) {
    const shouldCloseAfterTime = toaster.type !== TOASTER_TYPE.DANGER && !toaster.preventClose;
    toaster.id = this.ID();

    this.toasters$
      .asObservable()
      .pipe(take(1))
      .subscribe(toasters => {
        this.toasters$.next([...toasters, toaster]);
      });

    shouldCloseAfterTime &&
      setTimeout(() => {
        toaster.id && this.closeIt(toaster.id);
      }, toaster.timeToClose || 7000);
  }

  closeIt(toasterID: string) {
    this.toasters$
      .asObservable()
      .pipe(
        take(1),
        filter(toasters => toasters.find(toaster => toaster.id === toasterID) !== undefined),
      )
      .subscribe(toasters => {
        const filtredToasters = toasters.filter(toaster => toaster.id !== toasterID);

        const item$ = document.querySelector(`.js-toaster-${toasterID}`);
        item$?.classList.add('init-close');

        this.toasters$.next(filtredToasters);
      });
  }

  closeALL() {
    this.toasters$.next([]);
  }

  displaySuccess(message: string) {
    this.init({
      type: TOASTER_TYPE.SUCCESS,
      content: message,
    });
  }

  displayError(message: string) {
    this.init({
      type: TOASTER_TYPE.DANGER,
      content: message,
    });
  }

  displayWarning(message: string) {
    this.init({
      type: TOASTER_TYPE.WARNING,
      content: message,
    });
  }

  displayInfo(message: string) {
    this.init({
      type: TOASTER_TYPE.INFO,
      content: message,
    });
  }
}
